import React, { FC, useState } from 'react';

interface Props {
  onChangeStep: (step: number) => Promise<void>;
  currentStep: number;
}

const stepDetails = [
  { name: 'À commander', value: 1 },
  { name: 'Commandé', value: 2 },
  { name: 'Réceptionné', value: 3 },
  { name: 'En stock', value: 4 },
];

const Timeline: FC<Props> = ({ onChangeStep, currentStep }) => {
  const [loading, setLoading] = useState(false);

  const handleChangeStep = async (step: number) => {
    if (!loading) {
      setLoading(true);

      try {
        await onChangeStep(step);
      } catch (e) {}

      setLoading(false);
    }
  };

  return (
    <div className='panel-deal-infos'>
      <div className={'timeline ' + 'step' + currentStep + ' '}>
        <div className='timeline-flex'>
          {stepDetails.map((data, i) => (
            <div
              key={i}
              onClick={() => handleChangeStep(i + 1)}
              className={'prep-step-number ' + (currentStep == i + 1 ? 'selected ' : '')}
            >
              <span>{i + 1}</span>
            </div>
          ))}
        </div>
      </div>
      <div className='alignHorizontal'>
        <span className=''>
          <strong>{!loading ? stepDetails[currentStep - 1].name : 'Chargement ...'}</strong>
        </span>
      </div>
    </div>
  );
};

export default Timeline;
